(function($, B) {
    'use strict';
 
    B.web.toInit['main_menu'] = true;
    B.web.widgets['main_menu'] = {
        enabled: false,
        options:{
            expandedAttr : 'aria-expanded',
            openedAttr: 'aria-opened'
        },
        selectors: {
            nav: '#main_menu',
            menu: '#main-menu',
            trigger: '#main_menu_trigger',
            submenuToggle: '.submenu-toggle'
        },
        $elements:{
        },
        data:{
        },
        init:function(){
            Bajt.web.getElements(this.selectors, this.$elements);
            if(this.$elements.nav){
                this.enabled = true;
                this.bind();
            }
        },
        toggleSubmenu:function($btn){
            var $li=$btn.closest('li'),
                $parents = $li.parents('li'),
                expanded = parseInt($li.attr(this.options.expandedAttr));
            if(expanded != 1){//jesli menu ma być otwarte to zamknięcie wszystkich pozostałych pierwszego poziomu
                var $expanded = this.$elements.menu.children('[' + this.options.expandedAttr + '="1"]').not($parents);
                $expanded.attr(this.options.expandedAttr, 0);
            }
            $li.attr(this.options.expandedAttr, expanded == 1 ? 0 : 1);               
        },
        toggleMenu:function($btn){
            this.$elements.nav.attr(this.options.openedAttr, parseInt(this.$elements.nav.attr(this.options.openedAttr)) ? 0 : 1);
        },
        bind:function(){
            var that = this;
            this.$elements.submenuToggle.on('click touch', function(){
                that.toggleSubmenu($(this));
            });
            this.$elements.trigger.on('click touch', function(){
                that.toggleMenu($(this));
            });

        }
    };
})(jQuery, Bajt);
